import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./IconButton.module.styl";
import { Link } from "react-router-dom";
import { ReactComponent as BluePen } from "./assets/blue-pen.svg";
import { ReactComponent as RedCross } from "./assets/red-cross.svg";

function Icon(icon) {
    if (icon === "edit") return <BluePen />;
    if (icon === "remove") return <RedCross />;
    return <div>{icon}</div>;
}

function Content(icon, style, title, onClick, name) {
    return (
        <div>
            <span className={style} title={title} onClick={onClick} data-test-name={name}>
                <Icon icon={icon} />
            </span>
        </div>
    );
}

function IconButton({ to, name, onClick, title, className, icon, size }) {
    const sizeClass = styles["size_" + size];
    const style = cx(styles.button, className, sizeClass);

    if (to) {
        return (
            <Link to={to} data-test-name={name}>
                <Content icon={icon} style={style} title={title} onClick={onClick} name={name} />
            </Link>
        );
    }

    return <Content />;
}

IconButton.propTypes = {
    onClick: PropTypes.func,
    to: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    size: PropTypes.oneOf(["small", "medium"]),
};

IconButton.defaultProps = {
    size: "small",
};

export default IconButton;
